import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Grid, Form } from 'semantic-ui-react';

import {
  IngredientListingFieldEnum as Fields,
  IngredientFieldEnum,
} from 'Common/FieldEnum';
import { INGREDIENT_LISTING_REPORT_FORM_NAME } from 'Common/FormEnum';
import { TitledCard } from 'Components';
import { extractTruthyKeys } from 'Common/FormHelper';
import { ButtonGroupField } from 'Common/SemanticWrapper';

import { IngredientListingTable } from './IngredientListingTable';
import { BaseWeightOptions, SortByOptions } from '../helpers/Constants';

function IngredientListingReportForm({ change }) {
  const [selectedIngs, setSelectedIngs] = React.useState({});
  const [selectedAll, setSelectedAll] = React.useState(false);

  const onSelectIngredient = ing => {
    const id = ing[IngredientFieldEnum.Id];
    const nextSelected = !Boolean(selectedIngs[id]);
    setSelectedIngs({
      ...selectedIngs,
      [id]: nextSelected,
    });
  };

  const onSelectIngredients = (ingIds, checked) => {
    const nextSelectedIngs = { ...selectedIngs };
    ingIds.forEach(ingId => {
      nextSelectedIngs[ingId] = checked;
    });
    setSelectedIngs(nextSelectedIngs);
  };

  const onSelectAllToggle = () => {
    const nextSelectedAll = !selectedAll;
    setSelectedAll(nextSelectedAll);
    if (!nextSelectedAll) {
      setSelectedIngs({});
    }
  };

  React.useEffect(() => {
    change(Fields.All, selectedAll);
  }, [selectedAll]);

  React.useEffect(() => {
    const ingIds = extractTruthyKeys(selectedIngs);
    change(Fields.IngredientIds, ingIds);
  }, [selectedIngs]);

  return (
    <Form name={INGREDIENT_LISTING_REPORT_FORM_NAME}>
      <TitledCard title={'Report Parameters'}>
        <Grid>
          <Grid.Row>
            <Grid.Column width={6}>
              <Field
                name={Fields.BaseWeightType}
                label="Base Weight"
                component={ButtonGroupField}
                options={BaseWeightOptions}
                fluid
              />
            </Grid.Column>
            <Grid.Column width={6}>
              <Field
                name={Fields.SortBy}
                label="Sort By"
                component={ButtonGroupField}
                options={SortByOptions}
                fluid
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </TitledCard>
      <TitledCard title="Ingredients">
        <IngredientListingTable
          manual={true}
          selected={selectedIngs}
          onSelectIngredient={onSelectIngredient}
          onSelectIngredients={onSelectIngredients}
          onSelectAllToggle={onSelectAllToggle}
          selectedAll={selectedAll}
        />
      </TitledCard>
    </Form>
  );
}

export const IngredientListingForm = reduxForm({
  form: INGREDIENT_LISTING_REPORT_FORM_NAME,
  enableReinitialize: true,
  destroyOnUnmount: false,
})(IngredientListingReportForm);



// WEBPACK FOOTER //
// ./src/pages/ingredientlisting/components/IngredientListingForm.js